<template>
  <div>
    <div v-if="Object.keys(matchInfo).length" class="ticket-info-top team-info-top">
      <img :src="imageSrc(bgImg)" alt="">
      <div class="team-box">
        <div class="match">
          <div class="emblem">
            <p>{{matchInfo.home_team_full_name}}</p>
            <img :src="getEmblem(matchInfo.home_team)" alt="">
          </div>
          <div class="vs">
            <p class="top">
              {{ matchInfo.league_name_txt }}
            </p>
            <p class="date">{{ matchInfo.game_date }}<span>({{matchInfo.yoil}})</span></p>
            <p class="time">{{matchInfo.game_time}}</p>
            <p class="title">VS</p>
            <p class="home">홈</p>
          </div>
          <div class="emblem">
            <img :src="getEmblem(matchInfo.away_team)" alt="">
            <p>{{matchInfo.away_team_full_name}}</p>
          </div>
        </div>
        <p class="stadium">
          <span class="field">{{matchInfo.field_name}}</span>
          <span v-if="matchInfo.game_date !== '2025.09.27'">선예매: {{preReserveDate}} / 본예매: {{reserveDate}}</span>
          <span v-else>본예매: {{reserveDate}}</span>
        </p>
        <!-- 카운트다운 -->
        <CountDown :end-date="gameEndDate" :label="true" class="ticket-count-down" />
        <!-- 버튼 -->
        <div class="btn-div">
          <button v-if="isOpen" class="reservations" @click="callTicketing('ticketing')">티켓예매</button>
          <button class="check" @click="callTicketing('check')">예매확인</button>
<!--          <button class="policy" @click="modalOpen">티켓정책</button>-->
        </div>
      </div>
    </div>
    <div v-else class="ticket-season">
      <div class="sub-top">
        <img src="@/assets/img/banner/ticket_info.png" alt="">
        <div class="container">
          <img src="@/assets/img/login_bg.png" alt="">
          <div class="title">
            <p>시즌 일정 <span>준비중입니다.</span></p>
          </div>
          <div class="btn-div">
            <button class="check" @click="callTicketing('check')">예매확인</button>
            <button class="policy" @click="moveMatchList" style="margin-top: 10px;">경기일정</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getEmblem, checkBrowser} from '@/lib';
import CountDown from '@/components/Common/CountDown.vue';
import {ticketingFunc} from '@/lib/ticketingModule';
import dayjs from 'dayjs';

export default {
  name : 'TicketInfo',
  components: {CountDown},
  props: {
    match: Object
  },
  data() {
    return {
      bgImg: 'ticket_info',
      matchInfo: {},
      gameEndDate: '2023-09-16T07:00:00.000Z',
      isOpen: false,
      preReserveDate: '',
      reserveDate: ''
    }
  },
  watch: {
    match: {
      handler: function () {
        this.init();
      }
    }
  },
  created() {
  },
  mounted () {
    // this.init()
  },
  methods: {
    getEmblem,
    checkBrowser,
    init() {
      this.matchInfo = this.match;
      const gamedate = this.matchInfo.game_date.replace(/\./g, '-');
      this.gameEndDate = `${gamedate} ${this.matchInfo.game_time}:00`;


      if(this.matchInfo.meet_name.includes('K리그2')) {
        this.matchInfo.league_name_txt = 'K LEAGUE 2';
      } else if(this.matchInfo.meet_name.includes('FA컵')) {
        // 2024 FA컵 -> 코리아컵으로 변경
        this.matchInfo.league_name_txt = '코리아컵';
      }


      this.preReserveDate = dayjs(gamedate).subtract(7, 'day').format('MM.DD(ddd) 14:00');
      this.reserveDate = dayjs(gamedate).subtract(5, 'day').format('MM.DD(ddd) 14:00');

      const today = dayjs().format('YYYY-MM-DD');
      const matchDate = dayjs(gamedate).format('YYYY-MM-DD');
      // const matchDate = dayjs('2025-05-18').format('YYYY-MM-DD');
      const diffDays = dayjs(matchDate).diff(today, 'day');
      // console.log( 'today >>> ', dayjs(today));
      // console.log( 'matchDate >>> ', dayjs(matchDate));
      // console.log('diffDays >>> ', diffDays);

      const nowTime = dayjs().format('HH:mm:ss');
      const openTime = '13:50:00';
      // console.log('nowTime >>> ', nowTime);
      // console.log('time diff >>> ', nowTime >= openTime);
      if (diffDays === 7 && nowTime >= openTime) {
        this.isOpen = true;
      } else if (diffDays < 7) {
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/banner/'+imgSrc+'.png');
    },
    async callTicketing(type) {
      // 로그인 여부 확인
      if (!this.$store.state.login) {
        alert('로그인 후 이용 가능합니다.');
        // await this.$router.push('/login');
        await this.$router.push({name: 'login', params: {redirectUrl: '/ticket/reservations'}});
        return false;
      }
      let product_code = "";
      if(type === "ticketing") {
        await ticketingFunc({http: this.$http}, type, this.matchInfo.product_code);
      } else {
        await ticketingFunc({http: this.$http}, type);
      }

    },
    modalOpen() {
      this.$emit("modalOpen", true);
    },
    moveMatchList() {
      this.$router.push({name: 'matchList'});
    }
  }
}
</script>
